<template>
    <div>
        <staff-search-filters></staff-search-filters>

        <staff-search-top></staff-search-top>

        <staff-list :location-link="locationLink"></staff-list>
    </div>
</template>

<script>
    import StaffList from '@/components/StaffSearch/staff-list'
    import StaffSearchFilters from '@/components/StaffSearch/staff-search-filters'
    import StaffSearchTop from '@/components/StaffSearch/staff-search-top'

    export default {
        components: {
            StaffList,
            StaffSearchFilters,
            StaffSearchTop
        },

        computed: {
            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            }
        },

        props: {
            locationLink: {
                type: String
            }
        }
    }
</script>